export type ClientDiagnosticEvent = {
  href?: never
  [key: string]: unknown
}

export function postClientDiagnostic(path: string, event: ClientDiagnosticEvent): void {
  if (typeof window === 'undefined') return
  const payload = {
    ...event,
    href: window.location.href,
  }
  const body = JSON.stringify(payload)
  void fetch(path, {
    method: 'POST',
    credentials: 'include',
    keepalive: body.length < 60_000,
    headers: { 'Content-Type': 'application/json' },
    body,
  }).catch(() => undefined)
}
